import React from 'react';
import { LimitationEngine } from '../../utils/limitations';

interface UpgradePromptProps {
  isOpen: boolean;
  onClose: () => void;
  onUpgrade: () => void;
  feature: string;
  title?: string;
  message?: string;
}

export function UpgradePrompt({ 
  isOpen, 
  onClose, 
  onUpgrade, 
  feature,
  title,
  message 
}: UpgradePromptProps) {
  if (!isOpen) return null;

  const defaultTitle = "Upgrade to Premium";
  const defaultMessage = LimitationEngine.getUpgradeMessage(feature);
  const premiumFeatures = LimitationEngine.getPremiumFeatures();

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="account-modal-overlay" onClick={handleOverlayClick}>
      <div className="account-modal">
        <div className="account-modal-header">
          <h2 className="account-modal-title">
            {title || defaultTitle}
          </h2>
        </div>

        <div className="account-modal-content">
          <p className="upgrade-prompt-message">
            {message || defaultMessage}
          </p>

          <ul className="upgrade-features-list">
            {premiumFeatures.slice(0, 6).map((feature, index) => (
              <li key={index}>{feature}</li>
            ))}
          </ul>
        </div>

        <div className="account-modal-actions">
          <button 
            className="account-modal-btn-primary" 
            onClick={onUpgrade}
          >
            Upgrade Now&nbsp;<span className="upgrade-price">$9.99/month</span>
          </button>
          <button 
            className="account-modal-btn-secondary" 
            onClick={onClose}
          >
            Not Now
          </button>
        </div>
      </div>
    </div>
  );
}
